import React from 'react';
import { Icon } from './Icon.js';
export const IconShapePolygon = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 1.99995L21.9861 9.25528L18.1717 20.9946H5.82822L2.01388 9.25528L12 1.99995Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconShapePolygon.js.map